<template>
  <div class="specialtrad-list">
    <Table border :columns="columns" ref="selection" :data="tablelist" :loading="dataloading"></Table>
    <div style="margin: 10px;overflow: hidden">
      <div style="float: right;">
        <Page
          ref="listPage"
          :total="pages.total"
          :current="pages.page"
          :page-size="pages.size"
          show-elevator
          show-total
          @on-change="changePage()"
        ></Page>
      </div>
    </div>
    <!-- 添加的弹出 -->
    <Drawer
      :title="title"
      v-model="showDrawStatus"
      width="1000"
      :mask-closable="false"
      :styles="styles"
    >
      <Form :model="search">
        <FormItem label="请选择商品">
          <Select v-model="tablelist1" multiple filterable>
            <Option
              style="width:500px"
              v-for="item in goodsList"
              :value="item.good_id"
              :key="item.id"
            >{{ item.good_title }}</Option>
          </Select>
        </FormItem>
      </Form>
      <Form :model="search">
        <FormItem label="请选择活动">
          <Select v-model="tablelist2" multiple filterable>
            <Option v-for="item in liveList" :value="item.id" :key="item.id">{{ item.title }}</Option>
          </Select>
        </FormItem>
      </Form>
      <Form :model="search">
        <FormItem label="请选择定制">
          <Select v-model="tablelist3" multiple filterable>
            <Option v-for="item in customadeList" :value="item.id" :key="item.id">{{ item.title }}</Option>
          </Select>
        </FormItem>
      </Form>
      <div class="demo-drawer-footer">
        <Button style="margin-right: 8px" @click="showDrawStatus = false">取消</Button>
        <Button type="primary" @click="createSpecialTrad()">提交</Button>
      </div>
    </Drawer>
  </div>
</template>

<script>
import UploadThumb from "../common/thumb";
export default {
  name: "specialtrad-list",
  data() {
    return {
      title: "匠人列表",
      loading: true,
      dataloading: true,
      styles: {
        height: "calc(100% - 55px)",
        overflow: "auto",
        paddingBottom: "53px",
        position: "static"
      },
      search_s: {
        //专题商品等
        key: ""
      },
      columns: [
        {
          title: "匠人Id",
          key: "id",
          width: 100,
          fixed: "left"
        },
        {
          title: "店铺名称",
          key: "nickname",
          fixed: "left"
        },
        {
          title: "匠人等级",
          key: "auth_company",
          fixed: "left"
        },
        {
          title: "匠人手机号",
          key: "phone",
          fixed: "left"
        },
        {
          title: "缩略图",
          key: "thumb",
          fixed: "left",
          render: (h, params) => {
            const zUrl = "https://images.weserv.nl/?url=";
            let thumbImg =
              params.row.thumb.indexOf("https") > -1
                ? zUrl + params.row.thumb
                : params.row.thumb;
            return h("div", [
              h(
                "Avatar",
                {
                  props: {
                    src: thumbImg
                  }
                },
                ""
              )
            ]);
          }
        },
        {
          title: "排序",
          key: "sort",
          minWidth: 40,
          render: (h, params) => {
            return h("div", [
              h(
                "InputNumber",
                {
                  props: {
                    min: 0,
                    value: params.row.sort,
                    size: "small",
                    number: true,
                    activeChange: false
                  },
                  on: {
                    "on-change": value => {
                      this.sort(params.row.id, params.row.special_id, value);
                    }
                  }
                },
                "排序"
              )
            ]);
          }
        },
        {
          title: "操作",
          key: "action",
          align: "left",
          render: (h, params) => {
            return h("div", [
              h(
                "Button",
                {
                  style: {
                    marginRight: "8px"
                  },
                  props: {
                    type: "primary",
                    size: "small"
                  },
                  on: {
                    click: () => {
                      this.detail(params.row);
                    }
                  }
                },
                "详情"
              )
            ]);
          }
        }
      ],
      tablelist: [],
      tablelist1: [],
      tablelist2: [],
      tablelist3: [],
      goodsList: [],
      liveList: [],
      customadeList: [],
      list: [],
      type: "1", //专题类型1商品2约看
      search: {
        name: "",
        sort: 0,
        status: "0",
        tradesman_id: ""
      },
      pages: {
        page: 1,
        size: 10,
        total: 0
      },
      pages1: {
        page: 1,
        size: 99999,
        total: 0
      },
      showDrawStatus: false,
      showModalStatus: false
    };
  },
  // 计算
  computed: {},
  // 监听
  watch: {},
  created: function() {
    this.special_id = this.$route.params.params;
    // 取数据
    this.getTableList();
    this.getGoodsList();
    this.getLiveList();
    // this.getCustomadeList();
  },
  components: {
    UploadThumb
  },
  methods: {
    getTableList: function() {
      this.tablelist = [];
      var ps = {
        special_id: this.special_id,
        page: this.pages.page,
        size: this.pages.size
      };
      this.$api.specialtrad.list(ps).then(res => {
        this.dataloading = false;
        if (res.code == 200) {
          this.tablelist = res.result.list;
          this.pages.total = res.result.total;
          this.$Message.success(res.msg);
        }
      });
      return;
    },
    // 详情
    detail(tradesman) {
      this.title = "选择商品";
      //   this.liveList = [];
      //   this.goodsList = [];
      //   this.customadeList = [];
      this.showDrawStatus = !this.showDrawStatus;
      this.tradesman_id = tradesman.id;
      //   this.tablelist1 = [];
      //   this.tablelist2 = [];
      this.$api.specialtrad
        .detail({
          tradesman_id: this.tradesman_id,
          special_id: this.special_id
        })
        .then(res => {
          this.dataloading = false;
          if (res.code == 200) {
            this.tablelist1 = [];
            for (let i = 0; i < res.result.goods.length; i++) {
              const g = res.result.goods[i];
              this.tablelist1.push(g.id);
            }
            console.log("this.tablelist1:", this.tablelist1);
            this.tablelist2 = [];
            for (let i = 0; i < res.result.lives.length; i++) {
              const g = res.result.lives[i];
              this.tablelist2.push(g.id);
            }
            console.log("this.tablelist2:", this.tablelist2);
            this.tablelist3 = [];
            for (let i = 0; i < res.result.customades.length; i++) {
              const g = res.result.customades[i];
              this.tablelist3.push(g.id);
            }
          }
        });
      var ps = {
        status: 1,
        from_uuid: tradesman.tradesman.uuid,
        page: 1,
        size: 99999
      };
      this.$api.goods.list(ps).then(res => {
        if (res.code == 200) {
          this.goodsList = res.result.list;
        }
      });
      var ps2 = {
        status: 1,
        key: tradesman.nickname,
        page: 1,
        size: 99999
      };
      this.$api.lives.list(ps2).then(res => {
        this.dataloading = false;
        if (res.code == 200) {
          this.liveList = res.result.list;
        }
      });
      var ps3 = {
        status: 1,
        nickname: tradesman.nickname,
        page: 1,
        size: 99999
      };
      this.$api.custommade.list(ps3).then(res => {
        this.dataloading = false;
        if (res.code == 200) {
          this.customadeList = res.result.list;
          console.log(this.customadeList);
        }
      });
    },
    getGoodsList() {},
    getLiveList() {},
    sort: function(id, special_id, sort) {
      var that = this;
      this.$api.specialtrad
        .sort({ tradesman_id: id, special_id: special_id, sort: sort })
        .then(res => {
          if (res.code == 200) {
            this.$Message.success(res.msg);
            that.getTableList();
          }
        });
    },
    // 添加
    createSpecialTrad(name) {
      var tb = "";
      for (var i in this.tablelist1) {
        tb += this.tablelist1[i] + ",";
      }
      var tl = "";
      for (var i in this.tablelist2) {
        tl += this.tablelist2[i] + ",";
      }
      var tc = "";
      for (var i in this.tablelist3) {
        tc += this.tablelist3[i] + ",";
      }
      var ps = {
        good_id: tb,
        live_id: tl,
        tradesman_id: this.tradesman_id,
        customade_id: tc,
        special_id: this.special_id
      };
      this.$api.specialtrad.create(ps).then(res => {
        if (res.code == 200) {
          this.showDrawStatus = !this.showDrawStatus;
          this.getTableList();
        }
      });
    },
    remove: function(index) {
      // 弹出确认框
      this.$Modal.confirm({
        title: "警告",
        content: "<p>此操作不可恢复，三思而后行...</p>",
        onOk: () => {
          this.$api.special.remove({ id: index }).then(res => {
            if (res.code == 200) {
              this.$Message.success(res.msg);
              // this.tablelist.splice(index, 1);
              this.getTableList();
            }
          });
        }
      });
    },
    // 翻页
    changePage() {
      this.pages.page = this.$refs["listPage"].currentPage;
      this.renderTable(1);
    },
    // 筛选
    renderTable: function(name) {
      if (name != 1) {
        this.pages.page = 1;
      }
      this.dataloading = true;
      this.getTableList();
      return;
    }
  }
};
</script>
<style>
.demo-drawer-footer {
  width: 100%;
  height: 50px;
  position: absolute;
  bottom: 0;
  left: 0;
  border-top: 1px solid #e8e8e8;
  padding: 10px 16px;
  text-align: right;
  background: #fff;
}
</style>
